import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import Input from '~~elements/Input';
import Select from '~~elements/Select';
import Button from '~~elements/Button';
import Form from '~~elements/Form';
import { SectionDiv } from '../styled';
import CTMultilingual from '../Multilingual';
import { useCreateTournamentDispatch, useCreateTournamentState } from '../useCreateTournament';
import { validFormData } from '../service';
import {
  tournamentTypes,
  tournamentTeamTypes,
  tournamentPlayerTypes,
  tournamentBallTypes,
  tournamentBatTypes,
} from '../../Tournament/Const';

const Basic = ({ locations, nextLink }) => {
  const { formData } = useCreateTournamentState();
  const dispatch = useCreateTournamentDispatch();
  const nextStepLink = useRef(null);

  const handleInputOnChange = (e) => {
    if (e.target.name === 'auto_game_seq') {
      dispatch({
        type: 'UPDATE_FORM',
        payload: {
          ...formData,
          auto_game_seq: e.target.checked,
        },
      });
      return;
    }

    dispatch({
      type: 'UPDATE_FORM',
      payload: {
        ...formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleLocationOnChange = (index) => (e) => {
    formData.locations[index] = e.target.value;
    dispatch({
      type: 'UPDATE_FORM',
      payload: {
        ...formData,
        locations: [...formData.locations],
      },
    });
  };

  const handleLocationRemove = (index) => (e) => {
    e.preventDefault();
    const newLocations = [...formData.locations];
    newLocations.splice(index, 1);
    dispatch({
      type: 'UPDATE_FORM',
      payload: {
        ...formData,
        locations: newLocations,
      },
    });
  };

  const handleLocationCreate = (e) => {
    e.preventDefault();
    dispatch({
      type: 'UPDATE_FORM',
      payload: {
        ...formData,
        locations: [...formData.locations, ''],
      },
    });
  };

  const handleSubmit = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    if (!validFormData(formData, true)) {
      return;
    }

    nextStepLink.current.click();
  };

  return (
    <SectionDiv>
      <Form onSubmit={handleSubmit}>
        <div className="box">
          {/* 賽事名稱 */}
          <label>{CTMultilingual('TOURNAMENT.TITLE')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={CTMultilingual('TOURNAMENT.TITLE')}
                name="title"
                value={formData.title}
                onChange={handleInputOnChange}
                textAlign="left"
              />
            </div>
          </div>
          {/* 賽事型態 */}
          <label>{CTMultilingual('TOURNAMENT.TYPE')}</label>
          <div className="input-field">
            <Select width="100%" name="type" value={formData.type} onChange={handleInputOnChange}>
              {tournamentTypes.map((tournamentType) => (
                <option key={tournamentType} value={tournamentType}>
                  {CTMultilingual(`TOURNAMENT.TYPE_${tournamentType}`)}
                </option>
              ))}
            </Select>
          </div>
          <div className="row --multi-input-field">
            {/* 球隊型態 */}
            <div>
              <label>{CTMultilingual('TOURNAMENT.TEAM_TYPE.WORDING')}</label>
              <div className="input-field">
                <Select width="100%" name="team_type" value={formData.team_type} onChange={handleInputOnChange}>
                  {tournamentTeamTypes.map((tournamentTeamType) => (
                    <option key={tournamentTeamType} value={tournamentTeamType}>
                      {CTMultilingual(`TOURNAMENT.TEAM_TYPE.${tournamentTeamType}`)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            {/* 球員型態 */}
            <div>
              <label>{CTMultilingual('TOURNAMENT.PLAYER_TYPE.WORDING')}</label>
              <div className="input-field">
                <Select width="100%" name="player_type" value={formData.player_type} onChange={handleInputOnChange}>
                  {tournamentPlayerTypes.map((tournamentPlayerType) => (
                    <option key={tournamentPlayerType} value={tournamentPlayerType}>
                      {CTMultilingual(`TOURNAMENT.PLAYER_TYPE.${tournamentPlayerType}`)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="row --multi-input-field">
            {/* 比賽用球 */}
            <div>
              <label>{CTMultilingual('TOURNAMENT.BALL_TYPE.WORDING')}</label>
              <div className="input-field">
                <Select width="100%" name="ball_type" value={formData.ball_type} onChange={handleInputOnChange}>
                  {tournamentBallTypes.map((tournamentBallType) => (
                    <option key={tournamentBallType} value={tournamentBallType}>
                      {CTMultilingual(`TOURNAMENT.BALL_TYPE.${tournamentBallType}`)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            {/* 球棒要求 */}
            <div>
              <label>{CTMultilingual('TOURNAMENT.BAT_TYPE.WORDING')}</label>
              <div className="input-field">
                <Select width="100%" name="bat_type" value={formData.bat_type} onChange={handleInputOnChange}>
                  {tournamentBatTypes.map((tournamentBatType) => (
                    <option key={tournamentBatType} value={tournamentBatType}>
                      {CTMultilingual(`TOURNAMENT.BAT_TYPE.${tournamentBatType}`)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          {/* 賽事期間 */}
          <label>{CTMultilingual('TOURNAMENT.DATES')}</label>
          <div className="input-field --multi-input">
            <div className="input-box">
              <Input
                width="100%"
                type="date"
                name="start_at"
                value={formData.start_at}
                onChange={handleInputOnChange}
              />
              {` ~ `}
              <Input width="100%" type="date" name="end_at" value={formData.end_at} onChange={handleInputOnChange} />
            </div>
          </div>
          {/* 賽事自動編號 */}
          <label>
            <input
              type="checkbox"
              name="auto_game_seq"
              checked={formData.auto_game_seq}
              onChange={handleInputOnChange}
            />
            {CTMultilingual('TOURNAMENT.AUTO_GAME_SEQ_DESCRIPTION')}
          </label>
          <div className="input-field" />
          {/* 賽事使用球場 */}
          <label>
            {CTMultilingual('TOURNAMENT.SEASON_LOCATION')}
            <i className="info">{CTMultilingual('TOURNAMENT.SEASON_LOCATION_DESCRIPTION')}</i>
          </label>
          <div className="input-field">
            <div className="input-list">
              {formData.locations.map((locationUniqid, locationUniqidIndex) => (
                <label key={locationUniqidIndex} className="remove-icon-wrapper">
                  <Select
                    width="100%"
                    name="location"
                    value={locationUniqid}
                    onChange={handleLocationOnChange(locationUniqidIndex)}
                  >
                    <option value="">{CTMultilingual('FORM.PLEASE_SELECT')}</option>
                    {locations.map((location) => (
                      <option key={location.uniqid} value={location.uniqid}>
                        {`${location.city}｜${location.name}`}
                      </option>
                    ))}
                  </Select>
                  <Button width="unset" color="transparent" mini onClick={handleLocationRemove(locationUniqidIndex)}>
                    X
                  </Button>
                </label>
              ))}
              <label>
                <Button width="unset" color="transparentWithBorder" onClick={handleLocationCreate}>
                  {CTMultilingual(`COMMON.CREATE`)}
                </Button>
              </label>
            </div>
          </div>
          <Button width="unset" color="red" nowrap type="submit" disabled={!validFormData(formData, false)}>
            {CTMultilingual(`FORM.NEXT_STEP`)}
          </Button>
          <Link
            ref={nextStepLink}
            to={(location) => ({
              ...location,
              pathname: nextLink,
            })}
            style={{ display: 'none' }}
          />
        </div>
      </Form>
    </SectionDiv>
  );
};

export default Basic;
